// 基础配置接口
export function useConfigInfo (body, config) {
  return useHttp.post('/setting/infos', body ?? {}, config);
}

// 获取图库图片列表
// @params page keyWords language
export function useGetGalleryPage(body, config) {
  return useHttp.post("gallery/get_gallery_info", body, config);
}

// 热搜词列表
// @params pageNum pageSize language
export function useGetTrendsList(body, config) {
  return useHttp.post("search/trending", body, {
    ...config
  });
}

// 分类列表
export function useGetCategoryList(body, config) {
  return useHttp.post("/category/pageForWeb", body, {
    ...config
  });
}

// 搜索 => 相似词条列表
// @params keyWords language
export function useGetSimilarWordList(body, config) {
  return useHttp.post("/search/likeWords", body, {
    ...config
  });
}

// 获取图库图片详情
// @params taskId
export function useGetGalleryInfoDetail(body, config) {
  return useHttp.post("gallery/get_gallery_info_detail", body, config);
}

// 收藏
// @params taskId
export function useCollectPic(body, config) {
  return useHttp.post("gallery/collect", body, {
    client: true,
    ...config
  });
}

// 取消收藏
// @params taskId
export function useUncollectPic(body, config) {
  return useHttp.post("gallery/cancel_collect", body, {
    client: true,
    ...config
  });
}

// 举报图片
// @params taskId type content
export function useReportPic(body, config) {
  return useHttp.post("gallery/report", body, {
    client: true,
    ...config
  });
}


// sitemap列表
// @params pageNum pageSize language
export function useGetSitemapList(body, config) {
  return useHttp.post("siteMap/siteMapPageForWeb", body, {
    ...config
  });
}

// 图库图片支持多格式下载
export function useConvertImage(body, config) {
  return useHttp.post("convert/convert_image", body, {
    ...config
  });
}

// 图库列表收藏状态
export function useImageListCollect (body, config) {
  return useHttp.post("/creator/collectStatus", body, {
    ...config
  })
}
